import React, { useState, useRef, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { BsPlayFill, BsPauseFill } from 'react-icons/bs';
import './Timer.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import updatedCardImage from './updatedcard.jpg';

// Timer component
const Timer = (props) => {
  const { activeButton, setActiveButton } = props; 
  const [isPaused, setIsPaused] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [modalActiveButton2, setModalActiveButton2] = useState(false);
  const [questionModalShow, setQuestionModalShow] = useState(false);
  const [showFirstScreen, setShowFirstScreen] = useState(false);
  const intervalRef = useRef(null);
  const intervalleft = useRef(null);
  const [timeLeft, setTimeLeft] = useState(60);

  useEffect(() => {
    // Start the timer when not paused and active button is 1
    if (!isPaused && activeButton === 1) {
      intervalRef.current = setInterval(() => {
        props.setPrevTime((prevTime) => {
          const newTime = prevTime - 1;
          if (newTime === 0) {
            setModalShow(true); // show modal when time is over
            setIsPaused(true);
          }
          return newTime;
        });
      }, 1000);
    }


    if (activeButton === 2 && !props.showInfoPopup && !modalShow && !questionModalShow && !showFirstScreen) {
      intervalleft.current = setInterval(() => {
        setTimeLeft((prevSecond) => {
          const leftTime = prevSecond - 1;
          if (leftTime === 0) {
            setModalActiveButton2(true); // show modal when time is over
          }
          return leftTime;
        });
      }, 1000);

      return () => {
        clearInterval(intervalleft.current);
        setTimeLeft(60);
      };
    }
    // Clean up the interval when component unmounts or dependencies change
    return () => clearInterval(intervalRef.current);
  }, [isPaused, activeButton, props]);

  const formatTime = () => {
    const minutes = Math.floor(Math.abs(props.prevTime) / 60);
    const seconds = Math.abs(props.prevTime) % 60;
    const prefix = props.prevTime < 0 ? '-' : ''; // add minus sign if time is negative
    return `${prefix}${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  const handlePause = () => {
    if (!modalShow && !questionModalShow) {
      setIsPaused((prevPaused) => !prevPaused);
      setModalShow(true); // open modal when pausing
    }
  };

  const handleResume = () => {
    setIsPaused(false);
    setModalShow(false); // close modal when resuming
    setModalActiveButton2(false);
    setActiveButton(1);
  };

  const handleClick = () => {
    setModalShow(false);
    setQuestionModalShow(true);
    setShowFirstScreen(true);
  };

  const handleQuestionModalClose = () => {
    setQuestionModalShow(false);
  };

  return (
    <div className="timer-wrapper">
      <div className={`timer-container ${props.prevTime <= 0 ? 'negative' : ''}`}>
        <div className="timer">{formatTime()}</div>
      </div>
      <button className="pause-button" onClick={handlePause}>
        {isPaused ? <BsPlayFill size={34} /> : <BsPauseFill size={34} />}
      </button>
      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        handleResume={handleResume}
        handleClick={handleClick}
        activeButton={activeButton}
        time={formatTime()}
        gamemode={props.gamemode}
        time_counter = {props.prevTime}
      />

      <ModalActiveButton2
        show={modalActiveButton2}
        onHide={() => setModalActiveButton2(false)}
        setModalActiveButton2={setModalActiveButton2}
        setActiveButton={setActiveButton}
        handleClick={handleClick}
        activeButton={activeButton}
        time={formatTime()}
        setTimeLeft = {setTimeLeft}
        gamemode={props.gamemode}
        time_counter = {props.prevTime}
      />

      <QuestionModal
        show={questionModalShow}
        setQuestionModalShow={setQuestionModalShow}
        setModalShow={setModalShow}
        handleClose={handleQuestionModalClose}
        setShowFirstScreen={setShowFirstScreen}
        showFirstScreen={showFirstScreen}
      />
    </div>
  );
};

// Modal component
function MyVerticallyCenteredModal(props) {
  const { activeButton, handleResume, handleClick, time, time_counter, gamemode, ...modalProps } = props;

  return (
    <Modal {...modalProps} size="lg" centered backdrop="static" keyboard={false}>
      <Modal.Body>
        <div className="card-info">
          <div>
            
            <p>Verbleibende Zeit: {time}</p> {/* Remaining Time */}

            <p>Entworfen und entwickelt von Fraunhofer IEM</p> {/* Designed and developed by Fraunhofer IEM */}
            
            {!(gamemode === 1 && time_counter <= 0) && (
              <Button style={{ backgroundColor: "#009374", outline: "none", border: "none" }} onClick={handleResume}>
                Fortfahren {/* Continue */}
              </Button>
            )}
 
            <Button style={{ backgroundColor: "#009374", outline: "none", border: "none", marginLeft: '10px' }} onClick={handleClick}>
              Aufhören {/* Quit */}
            </Button>

          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}


// Modal For Active Button second
function ModalActiveButton2(props) {
  const { activeButton, setModalActiveButton2, setActiveButton, handleClick, time, time_counter, setTimeLeft, gamemode, ...modalProps } = props;

  return (
    <Modal {...modalProps} size="lg" centered backdrop="static" keyboard={false}>
      <Modal.Body>
        <div className="card-info">
          <div>
            
            <p>Verbleibende Zeit: {time}</p> {/* Remaining Time */}
            <p>Entworfen und entwickelt von Fraunhofer IEM</p> {/* Designed and developed by Fraunhofer IEM */}
            <p>Scheint so, als wärst du inaktiv. Möchtest du spielen und Karten kombinieren? Klicke auf den "Kombinieren"-Button, um fortzufahren.</p>
            
            <Button
              style={{ backgroundColor: "#009374", outline: "none", border: "none", marginLeft: '10px' }}
              onClick={() => {setActiveButton(1); setModalActiveButton2(false);} }
            >
              Kombinieren
            </Button>

            <Button
              style={{ backgroundColor: "#009374", outline: "none", border: "none", marginLeft: '10px' }}
              onClick={() => {setActiveButton(2); setModalActiveButton2(false); setTimeLeft(60);} }
            >
              Info
            </Button>

            <Button
              style={{ backgroundColor: "#009374", outline: "none", border: "none", marginLeft: '10px' }}
              onClick={() => {handleClick(); setModalActiveButton2(false);}}
            >
              Aufhören
            </Button>

          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}



function QuestionModal(props) {
  
  // Here Screen refer to Modal
  const { show, handleClose, setModalShow, setQuestionModalShow, setShowFirstScreen,showFirstScreen } = props;
  const [quitConfirm, setQuitOption] = useState("");
  const [updatedCard, setUpdatedCard ] = useState("");
  const [noofupdatedCard, setNoOfUdatedCard]= useState("");
  const [showSecondScreen, setShowSecondScreen] = useState(false);
  const [showThirdScreen, setShowThirdScreen] = useState(false);
  const [result, setResult] = useState("");
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(true);
  const [submitfirstButtonDisabled, setfirstSubmitButtonDisabled] = useState(true);

  const handleCloseModal = () => {
    handleClose();
  };

  const handleQuit = (event) => {
    setQuitOption(event.target.value);
  };

  const handleupdatedCard = (event) => {
    setUpdatedCard(event.target.value);
  };

  const handlenoupdatedCard = (event) => {
    setNoOfUdatedCard(event.target.value);
  };

  const handleOptionSubmitFirst = () => {
    setShowFirstScreen(false);
    setShowThirdScreen(false);
    if(quitConfirm === "option2"){
      setShowSecondScreen(false);
      setfirstSubmitButtonDisabled(true);
      setSubmitButtonDisabled(true);
      setQuitOption("");
      setUpdatedCard("");
      setNoOfUdatedCard("");
      setModalShow(true);
      setQuestionModalShow(false);
    }
    else{
      setShowSecondScreen(true);
    }
  };

  const handleOptionSubmitSecond = () => {
    setShowFirstScreen(false);
    setShowSecondScreen(false);
    setShowThirdScreen(true);
    let response = "";
    if (updatedCard === "option3" && noofupdatedCard === "option5") {
      response = "Hervorragend - Ihr habt den BBiQ durch Anwendung von Systems Engineering erfolgreich entwickelt. Alle Beteiligten sind zufrieden; herzlichen Glückwunsch!";
    } else if (updatedCard === "option3" && noofupdatedCard === "option6") {
      response = "Gut gemacht: - Ihr habt durch die Anwendung von Systems Engineering ein fast erfolgreiches Produkt entwickelt. Da ihr nicht alle Methoden miteinander verknüpft habt, werden im Betrieb des BBiQ-noch  einige Probleme auftreten.";
    } else if (updatedCard === "option3" && noofupdatedCard === "option7") {
      response = "Noch okay - Ihr habt ein brauchbares Produkt entwickelt. Da ihr  viele Methoden nicht miteinander verknüpft habt, fehlen einige wichtige Funktionen. Dadurch sind ncht alle Stakholder zufrieden.";
    } else if (updatedCard === "option4" && noofupdatedCard === "option5") {
      response = "Akzeptabel - Da Ihr keinen validierten Prototyp habt, seid ihr euch nicht sicher, ob Ihr BBiQ den Anforderungen der Stakeholder entspricht. Durch die Verknüpfung der verschiedenen Methoden habt ihr jedoch die Wahrscheinlichkeit dafür deutlich erhöht.";
    } else if (updatedCard === "option4" && noofupdatedCard === "option6") {
      response = "Kein Erfolg - Die Entwicklung des BBiQ war kein Erfolg. Da Ihr Systems Engineering eingesetzt und ausreichend Methoden miteinander kombiniert habt, konntet ihr die Entwicklung stoppen, bevor mehr Schaden entstand.";
    } else if (updatedCard === "option4" && noofupdatedCard === "option7") {
      response = "Worst Case- Das ist eine Katastrophe! Ihr habt weder ausreichend Methoden miteiander verknüpft, noch einen validierten Prototyp. Köpfe werden rollen, hoffentlich nicht Eure.";
    }


    setResult(response);
  };

  const handleBack = () => {
    setShowFirstScreen(false);
    setShowSecondScreen(false);
    setShowThirdScreen(false);
    setfirstSubmitButtonDisabled(true);
    setSubmitButtonDisabled(true);
    setQuitOption("");
    setUpdatedCard("");
    setNoOfUdatedCard("");
    setModalShow(true);
    setQuestionModalShow(false);
  };

  const handleGoBack = () => {

    setShowFirstScreen(true);
    setShowSecondScreen(false);
    setShowThirdScreen(false);
    setfirstSubmitButtonDisabled(true);
    setSubmitButtonDisabled(true);

    setQuitOption("");
    setUpdatedCard("");
    setNoOfUdatedCard("");


  };

  const GameEnd = () => {
    window.location.href = '/dev-info';
  };

  useEffect(() => {
    // Update the disabled state based on selected options
    setSubmitButtonDisabled(!(updatedCard && noofupdatedCard));
    setfirstSubmitButtonDisabled(!quitConfirm);
  }, [quitConfirm, updatedCard,noofupdatedCard]);

  return (
    <Modal show={show} onHide={handleCloseModal} size="lg" centered backdrop="static" keyboard={false}>
      
      
      {showSecondScreen && quitConfirm && (
        <Modal.Header>
              <Modal.Title id="contained-modal-title-vcenter">
                Frage
              </Modal.Title>
        </Modal.Header>
      )}

      {showThirdScreen && (
        <Modal.Header>
            <Modal.Title id="contained-modal-title-vcenter">
              Ergebnis
            </Modal.Title>
        </Modal.Header>
      )}

      
      <Modal.Body>
        <div className="card-info">
          <div className="question-modal  p-1">
            {showFirstScreen && (
              <div>
              <p>Möchten Sie wirklich beenden?</p>
              <div className='form-group form-check' style={{marginBottom: '15px'}}>
                  <div>
                    <input className="form-check-input" type="radio" id="option1" name="options" value="option1" onChange={handleQuit} />
                    <label className="form-check-label" htmlFor="option1">Ja</label>
                  </div>
                  <div>
                    <input className="form-check-input" type="radio" id="option2" name="options" value="option2" onChange={handleQuit} />
                    <label className="form-check-label" htmlFor="option2">Nein</label>
                  </div>
              </div>
              </div>
            )}

            {showSecondScreen && quitConfirm && (
              <div>
                <Row>
                  <Col className='text-justify' sm={9}>
                <div>
                  <div>
                    <p>Habt ihr den verifizierten und validierten Prototypen (Karte33)?</p>
                    <div className='form-group form-check' style={{ marginBottom: '15px' }}>
                      <div>
                        <input className="form-check-input" type="radio" id="option3" name="optionsone" value="option3" onChange={handleupdatedCard} />
                        <label className="form-check-label" htmlFor="option3">Ja</label>
                      </div>
                      <div>
                        <input className="form-check-input" type="radio" id="option4" name="optionsone" value="option4" onChange={handleupdatedCard} />
                        <label className="form-check-label" htmlFor="option4">Nein</label>
                      </div>
                    </div>
                  </div>
                
                {updatedCard &&(
                  <div>
                  <p>Wieviele aktualisierte Methodenkarten habt ihr?</p>
                  <div className='form-group form-check' style={{ marginBottom: '15px' }}>
                    <div>
                      <input
                        className="form-check-input"
                        type="radio"
                        id="option5"
                        name="options"
                        value="option5"
                        onChange={handlenoupdatedCard}
                      />
                      <label className="form-check-label" htmlFor="option5">zwischen 12 und 9</label>
                    </div>

                    <div>
                      <input
                        className="form-check-input"
                        type="radio"
                        id="option6"
                        name="options"
                        value="option6"
                        onChange={handlenoupdatedCard}
                      />
                      <label className="form-check-label" htmlFor="option6">zwischen 8 und 5</label>
                    </div>

                    <div>
                      <input className="form-check-input" type="radio" id="option7" name="options" value="option7" onChange={handlenoupdatedCard} />
                      <label className="form-check-label" htmlFor="option7">zwsichen 4 und 1</label>
                    </div>
                  </div>
                  </div>
                  )}
                </div>

              
                </Col>

                    <Col className='text-center' sm={3}>
                      {/* Right column */}
                      <div>
                        <img className='img-fluid' src={updatedCardImage} alt="Card" />
                      </div>
                    </Col>
                  </Row>


              </div>

             

            )}

            {showThirdScreen && (
              <div>
                <div>
                  <p>{result}</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </Modal.Body>
    
      <Modal.Footer>
        
        {showFirstScreen && (
          <div>
          <Button style={{ backgroundColor: "#009374", outline: "none", border: "none" }} onClick={handleOptionSubmitFirst} disabled={submitfirstButtonDisabled}>
            Absenden
          </Button>

          <Button style={{ backgroundColor: "#009374", outline: "none", border: "none", marginLeft: '10px' }} onClick={handleBack}>
            Zurück
          </Button>
          </div>
        )}
      
        {showSecondScreen && quitConfirm && (
          <div>
                <Button style={{ backgroundColor: "#009374", outline: "none", border: "none" }} onClick={handleOptionSubmitSecond} disabled={submitButtonDisabled}>
                  Absenden
                </Button>

                <Button style={{ backgroundColor: "#009374", outline: "none", border: "none", marginLeft: '10px' }} onClick={handleGoBack}>
                  Zurück
                </Button>
          </div>

        )}

        {showThirdScreen && (
            <div>
              <Button style={{ backgroundColor: "#009374", outline: "none", border: "none" }} onClick={GameEnd}>
                Spiel beenden
              </Button>
            </div>
        )}

      </Modal.Footer>  
    </Modal>
  );
}

export default Timer;